const dataExample = {
  region: { id: 9, name: 'nm_meso' },
  selected: {
    id: false,
    latitude: true,
    longitude: true,
    city: false,
    disease: false,
    cd_mun: false,
    cd_micro: false,
    nm_micro: false,
    cd_meso: false,
    nm_meso: false,
    cd_crs: false,
    nm_crs: false,
  },
  data: [
    [
      'id',
      'latitude',
      'longitude',
      'city',
      'disease',
      'cd_mun',
      'cd_micro',
      'nm_micro',
      'cd_meso',
      'nm_meso',
      'cd_crs',
      'nm_crs',
    ],
    [
      1,
      '-29.6755612',
      '-52.7982653',
      'Candelária',
      'HAC',
      4304200,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      2,
      '-28.2265726',
      '-51.5152504',
      'Lagoa Vermelha',
      'HAC',
      4311304,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      3,
      '-29.99476',
      '-53.615593',
      'Formigueiro',
      'HAC',
      4308409,
      43019,
      'Restinga Seca',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      4,
      '-30.5148445',
      '-53.4832383',
      'Caçapava do Sul',
      'HAC',
      4302808,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
      8,
      'Cachoeira do Sul',
    ],
    [
      5,
      '-29.542451',
      '-51.0835851',
      'Morro Reuter',
      'HAC',
      4312476,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      6,
      '-29.4889309',
      '-51.9690079',
      'Estrela',
      'HAC',
      4307807,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      7,
      '-28.9318491',
      '-51.55018399999999',
      'Veranópolis',
      'HAC',
      4322806,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      8,
      '-29.6135784',
      '-53.4439316',
      'São João do Polêsine',
      'HAC',
      4318432,
      43019,
      'Restinga Seca',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      9,
      '-29.2394661',
      '-52.3089942',
      'Progresso',
      'HAC',
      4315156,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      10,
      '-29.231286',
      '-51.323443',
      'Farroupilha',
      'HAC',
      4307906,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      11,
      '-28.5064802',
      '-50.9304594',
      'Vacaria',
      'HAC',
      4322509,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      12,
      '-30.0385149',
      '-51.0802783',
      'Alvorada',
      'HAC',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      13,
      '-29.9990734',
      '-51.2959',
      'Eldorado do Sul',
      'HAC',
      4306767,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      14,
      '-29.4714195',
      '-51.8307854',
      'Teutônia',
      'HAC',
      4321451,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      15,
      '-29.7411776',
      '-52.4369395',
      'Santa Cruz do Sul',
      'HAC',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      16,
      '-27.5682901',
      '-51.6707891',
      'Machadinho',
      'HAC',
      4311700,
      43005,
      'Sananduva',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      17,
      '-30.06659149999999',
      '-51.194872',
      'Porto Alegre',
      'HAC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      18,
      '-31.3302778',
      '-54.1022741',
      'Bagé',
      'HAC',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
      7,
      'Bagé',
    ],
    [
      19,
      '-32.0343157',
      '-52.08300209999999',
      'Rio Grande',
      'HAC',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      20,
      '-28.40818',
      '-54.9615405',
      'São Luiz Gonzaga',
      'HAC',
      4318903,
      43007,
      'Santo Ângelo',
      4301,
      'Noroeste Rio-grandense',
      12,
      'Santo Ângelo',
    ],
    [
      21,
      '-30.03693489999999',
      '-51.1038416',
      'Porto Alegre',
      'HAC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      22,
      '-29.4889309',
      '-51.9690079',
      'Estrela',
      'HAC',
      4307807,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      23,
      '-30.099674',
      '-51.248311',
      'Porto Alegre',
      'HAC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      24,
      '-29.5092569',
      '-51.9691601',
      'Estrela',
      'HAC',
      4307807,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      25,
      '-29.9083261',
      '-51.0791774',
      'Cachoeirinha',
      'HAC',
      4303103,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      26,
      '-29.9420238',
      '-51.0224938',
      'Gravataí',
      'HAC',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      27,
      '-30.0125444',
      '-51.1384492',
      'Porto Alegre',
      'HAC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      28,
      '-29.5405077',
      '-49.8970321',
      'Arroio do Sal',
      'HAC',
      4301057,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      29,
      '-29.5405077',
      '-49.8970321',
      'Arroio do Sal',
      'HAC',
      4301057,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      30,
      '-29.7307861',
      '-53.8126117',
      'Santa Maria',
      'HAC',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      31,
      '-27.4559325',
      '-53.9301575',
      'Três Passos',
      'HAC',
      4321907,
      43002,
      'Três Passos',
      4301,
      'Noroeste Rio-grandense',
      19,
      'Frederico Westphalen',
    ],
    [
      32,
      '-29.9942499',
      '-51.31207029999999',
      'Eldorado do Sul',
      'HAC',
      4306767,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      33,
      '-32.0677064',
      '-52.1772747',
      'Rio Grande',
      'HAC',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      34,
      '-27.7222015',
      '-53.7166073',
      'Coronel Bicaco',
      'HAC',
      4305900,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
      15,
      'Palmeira das Missões',
    ],
    [
      35,
      '-31.325387',
      '-54.1002398',
      'Bagé',
      'HAC',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
      7,
      'Bagé',
    ],
    [
      36,
      '-29.588995',
      '-51.374274',
      'São Sebastião do Caí',
      'HAC',
      4319505,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      37,
      '-30.0680527',
      '-51.080608',
      'Viamão',
      'FC',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      38,
      '-27.8629644',
      '-54.4464158',
      'Santa Rosa',
      'FC',
      4317202,
      43001,
      'Santa Rosa',
      4301,
      'Noroeste Rio-grandense',
      14,
      'Santa Rosa',
    ],
    [
      39,
      '-29.4134723',
      '-49.97775300000001',
      'Três Cachoeiras',
      'FC',
      4321667,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      40,
      '-30.1291914',
      '-51.2284474',
      'Porto Alegre',
      'FC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      41,
      '-30.5966455',
      '-51.7518126',
      'Cerro Grande do Sul',
      'FC',
      4305173,
      43028,
      'Camaquã',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      42,
      '-29.5475556',
      '-50.7790831',
      'Igrejinha',
      'FC',
      4310108,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      43,
      '-29.902191',
      '-51.22264',
      'Canoas',
      'FC',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      44,
      '-30.1473627',
      '-50.5122459',
      'Capivari do Sul',
      'FC',
      4304671,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      45,
      '-27.9535859',
      '-55.2746252',
      'Roque Gonzales',
      'FC',
      4316303,
      43006,
      'Cerro Largo',
      4301,
      'Noroeste Rio-grandense',
      12,
      'Santo Ângelo',
    ],
    [
      46,
      '-29.040625',
      '-53.171569',
      'Salto do Jacuí',
      'FC',
      4316451,
      43011,
      'Cruz Alta',
      4301,
      'Noroeste Rio-grandense',
      9,
      'Cruz Alta',
    ],
    [
      47,
      '-30.00530819999999',
      '-51.0971213',
      'Porto Alegre',
      'FC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      48,
      '-29.6365868',
      '-50.9809911',
      'Sapiranga',
      'FC',
      4319901,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      49,
      '-28.2671982',
      '-52.3782716',
      'Passo Fundo',
      'FC',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      50,
      '-28.3025454',
      '-52.7811645',
      'Carazinho',
      'FC',
      4304705,
      43009,
      'Carazinho',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      51,
      '-28.3154501',
      '-53.50300739999999',
      'Panambi',
      'FC',
      4313904,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
      17,
      'Ijuí',
    ],
    [
      52,
      '-31.7249222',
      '-52.346447',
      'Pelotas',
      'FC',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      53,
      '-31.7313373',
      '-52.390029',
      'Pelotas',
      'FC',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      54,
      '-28.6308108',
      '-53.09559119999999',
      'Ibirubá',
      'FC',
      4310009,
      43011,
      'Cruz Alta',
      4301,
      'Noroeste Rio-grandense',
      9,
      'Cruz Alta',
    ],
    [
      55,
      '-29.2148564',
      '-52.0265488',
      'Nova Bréscia',
      'FC',
      4313003,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      56,
      '-30.1519738',
      '-51.3330287',
      'Guaíba',
      'FC',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      57,
      '-29.5522424',
      '-51.4167761',
      'Harmonia',
      'FC',
      4309555,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      58,
      '-29.8960845',
      '-50.2669404',
      'Osório',
      'FC',
      4313508,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      59,
      '-29.6515532',
      '-51.1115082',
      'Novo Hamburgo',
      'FC',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      60,
      '-27.7716237',
      '-53.2558458',
      'São Pedro das Missões',
      'FC',
      4319364,
      43009,
      'Carazinho',
      4301,
      'Noroeste Rio-grandense',
      15,
      'Palmeira das Missões',
    ],
    [
      61,
      '-29.896913',
      '-50.3050633',
      'Osório',
      'FC',
      4313508,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      62,
      '-28.0828513',
      '-53.70740499999999',
      'Nova Ramada',
      'FC',
      4313334,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
      17,
      'Ijuí',
    ],
    [
      63,
      '-29.484664',
      '-52.9229478',
      'Passa Sete',
      'FC',
      4314068,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      8,
      'Cachoeira do Sul',
    ],
    [
      64,
      '-29.9983254',
      '-51.0592507',
      'Alvorada',
      'FC',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      65,
      '-28.9809591',
      '-50.1009527',
      'Cambará do Sul',
      'FC',
      4303608,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      1,
      'Porto Alegre',
    ],
    [
      66,
      '-29.2495153',
      '-51.8757988',
      'Encantado',
      'FC',
      4306809,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      67,
      '-30.0529902',
      '-51.2005267',
      'Porto Alegre',
      'FC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      68,
      '-29.5812545',
      '-51.0865936',
      'Dois Irmãos',
      'FC',
      4306403,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      69,
      '-29.9317187',
      '-50.9543434',
      'Gravataí',
      'FC',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      70,
      '-29.56929209999999',
      '-50.8045891',
      'Igrejinha',
      'FC',
      4310108,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      71,
      '-30.0961912',
      '-51.1315713',
      'Porto Alegre',
      'FC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      72,
      '-29.6507371',
      '-51.1669881',
      'Estância Velha',
      'FC',
      4307609,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      73,
      '-28.259223',
      '-52.3982685',
      'Passo Fundo',
      'FC',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      74,
      '-29.7196254',
      '-51.1455531',
      'São Leopoldo',
      'FC',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      75,
      '-29.356384',
      '-50.7959724',
      'Canela',
      'FC',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      5,
      'Caxias do Sul',
    ],
    [
      76,
      '-30.1592646',
      '-51.1390881',
      'Porto Alegre',
      'FC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      77,
      '-29.9207867',
      '-51.0467462',
      'Gravataí',
      'FC',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      78,
      '-28.283642',
      '-52.374584',
      'Passo Fundo',
      'FC',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      79,
      '-29.1688447',
      '-51.1234028',
      'Caxias do Sul',
      'FC',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      80,
      '-28.2855257',
      '-52.3659184',
      'Passo Fundo',
      'FC',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      81,
      '-30.1018486',
      '-51.1706122',
      'Porto Alegre',
      'FC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      82,
      '-29.6821351',
      '-52.8428328',
      'Novo Hamburgo',
      'FC',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      83,
      '-29.891047',
      '-51.141148',
      'Canoas',
      'FC',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      84,
      '-27.4538017',
      '-53.9271823',
      'Três Passos',
      'FC',
      4321907,
      43002,
      'Três Passos',
      4301,
      'Noroeste Rio-grandense',
      19,
      'Frederico Westphalen',
    ],
    [
      85,
      '-30.0280821',
      '-51.1033615',
      'Porto Alegre',
      'FC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      86,
      '-29.7111281',
      '-52.5237648',
      'Vera Cruz',
      'FC',
      4322707,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      87,
      '-27.6899678',
      '-51.6157348',
      'São José do Ouro',
      'FC',
      4318606,
      43005,
      'Sananduva',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      88,
      '-31.2777373',
      '-52.7636889',
      'Canguçu',
      'FC',
      4304507,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      89,
      '-29.6154131',
      '-52.20700040000001',
      'Venâncio Aires',
      'FC',
      4322608,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      90,
      '-29.7332747',
      '-51.1286499',
      'Novo Hamburgo',
      'FC',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      91,
      '-29.9632237',
      '-51.19390600000001',
      'Canoas',
      'FC',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      92,
      '-29.1637544',
      '-51.52269500000001',
      'Bento Gonçalves',
      'FC',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      93,
      '-29.894544',
      '-50.24666269999999',
      'Osório',
      'FC',
      4313508,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      94,
      '-28.5071196',
      '-50.941176',
      'Vacaria',
      'FC',
      4322509,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      95,
      '-29.459582',
      '-51.96494209999999',
      'Lajeado',
      'FC',
      4311403,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      96,
      '-27.6906821',
      '-54.22537269999999',
      'Três de Maio',
      'FC',
      4321808,
      43001,
      'Santa Rosa',
      4301,
      'Noroeste Rio-grandense',
      14,
      'Santa Rosa',
    ],
    [
      97,
      '-31.5826552',
      '-53.3841936',
      'Pinheiro Machado',
      'FC',
      4314506,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      98,
      '-29.9218324',
      '-50.9352696',
      'Gravataí',
      'FC',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      99,
      '-29.7494039',
      '-51.1655762',
      'São Leopoldo',
      'FC',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      100,
      '-28.3148897',
      '-53.513712',
      'Panambi',
      'FC',
      4313904,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
      17,
      'Ijuí',
    ],
    [
      101,
      '-27.9616607',
      '-51.7944589',
      'Sananduva',
      'FC',
      4316600,
      43005,
      'Sananduva',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      102,
      '-30.1133979',
      '-51.9622936',
      'Butiá',
      'FC',
      4302709,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      103,
      '-29.36668',
      '-50.7949349',
      'Canela',
      'FC',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      5,
      'Caxias do Sul',
    ],
    [
      104,
      '-28.4999614',
      '-51.7042323',
      'São Jorge',
      'FC',
      4318440,
      43014,
      'Guaporé',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      105,
      '-31.308545',
      '-54.0962669',
      'Bagé',
      'FC',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
      7,
      'Bagé',
    ],
    [
      106,
      '-30.02733749999999',
      '-51.1505664',
      'Porto Alegre',
      'FC',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      107,
      '-30.0616038',
      '-51.1133506',
      'Viamão',
      'FC',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      108,
      '-30.2533247',
      '-54.9205943',
      'Rosário do Sul',
      'FC',
      4316402,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      109,
      '-29.6824252',
      '-53.8382565',
      'Santa Maria',
      'FC',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      110,
      '-28.2644849',
      '-52.4274619',
      'Passo Fundo',
      'FC',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      111,
      '-27.6906821',
      '-54.22537269999999',
      'Três de Maio',
      'FC',
      4321808,
      43001,
      'Santa Rosa',
      4301,
      'Noroeste Rio-grandense',
      14,
      'Santa Rosa',
    ],
    [
      112,
      '-31.2634559',
      '-52.6172766',
      'Canguçu',
      'FC',
      4304507,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      113,
      '-28.282418',
      '-54.2625233',
      'Santo Ângelo',
      'FC',
      4317509,
      43007,
      'Santo Ângelo',
      4301,
      'Noroeste Rio-grandense',
      12,
      'Santo Ângelo',
    ],
    [
      114,
      '-30.1234261',
      '-51.3169635',
      'Guaíba',
      'Hb',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      115,
      '-29.6540396',
      '-51.1848488',
      'Estância Velha',
      'Hb',
      4307609,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      116,
      '-30.162987',
      '-51.2308303',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      117,
      '-29.7820536',
      '-57.1055466',
      'Uruguaiana',
      'Hb',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      118,
      '-30.0748914',
      '-51.184408',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      119,
      '-27.6765124',
      '-53.80178830000001',
      'Campo Novo',
      'Hb',
      4304002,
      43002,
      'Três Passos',
      4301,
      'Noroeste Rio-grandense',
      17,
      'Ijuí',
    ],
    [
      120,
      '-27.3600576',
      '-53.5585464',
      'Palmitinho',
      'Hb',
      4313805,
      43003,
      'Frederico Westphalen',
      4301,
      'Noroeste Rio-grandense',
      19,
      'Frederico Westphalen',
    ],
    [
      121,
      '-30.0324193',
      '-51.0579895',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      122,
      '-31.737399',
      '-52.31665460000001',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      123,
      '-29.9527012',
      '-51.6285417',
      'Charqueadas',
      'Hb',
      4305355,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      124,
      '-29.3049992',
      '-52.43217019999999',
      'Boqueirão do Leão',
      'Hb',
      4302451,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      125,
      '-27.5303232',
      '-52.7352199',
      'Entre Rios do Sul',
      'Hb',
      4306957,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
      11,
      'Erechim',
    ],
    [
      126,
      '-30.0598869',
      '-51.1796538',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      127,
      '-30.0767783',
      '-51.1895395',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      128,
      '-30.0685974',
      '-51.2136327',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      129,
      '-29.687634',
      '-53.8129003',
      'Santa Maria',
      'Hb',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      130,
      '-30.3358886',
      '-54.3213145',
      'São Gabriel',
      'Hb',
      4318309,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      131,
      '-29.8896035',
      '-50.7747955',
      'Glorinha',
      'Hb',
      4309050,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      132,
      '-29.7581139',
      '-52.440893',
      'Santa Cruz do Sul',
      'Hb',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      133,
      '-30.0136061',
      '-51.1598138',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      134,
      '-30.0416028',
      '-51.21632049999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      135,
      '-30.00093609999999',
      '-51.0974586',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      136,
      '-28.0718449',
      '-53.5428522',
      'Condor',
      'Hb',
      4305702,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
      17,
      'Ijuí',
    ],
    [
      137,
      '-30.02859429999999',
      '-51.1299856',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      138,
      '-29.9839133',
      '-51.06278709999999',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      139,
      '-29.5137043',
      '-51.99249',
      'Cruzeiro do Sul',
      'Hb',
      4306205,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      140,
      '-29.7549941',
      '-51.150283',
      'São Leopoldo',
      'Hb',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      141,
      '-31.7474816',
      '-52.3702228',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      142,
      '-31.7403795',
      '-52.3975076',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      143,
      '-30.1409953',
      '-52.0442677',
      'Minas do Leão',
      'Hb',
      4312252,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      144,
      '-29.623395',
      '-52.179129',
      'Venâncio Aires',
      'Hb',
      4322608,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      145,
      '-30.1284168',
      '-51.11041119999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      146,
      '-31.3284966',
      '-54.092275',
      'Bagé',
      'Hb',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
      7,
      'Bagé',
    ],
    [
      147,
      '-30.0346471',
      '-51.2176584',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      148,
      '-29.9563421',
      '-51.72019359999999',
      'São Jerônimo',
      'Hb',
      4318408,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      149,
      '-29.8392168',
      '-51.1517201',
      'Sapucaia do Sul',
      'Hb',
      4320008,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      150,
      '-32.0430745',
      '-52.1213737',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      151,
      '-30.0346471',
      '-51.2176584',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      152,
      '-29.9830566',
      '-51.1863355',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      153,
      '-30.0806754',
      '-51.0008063',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      154,
      '-30.1167905',
      '-51.2247969',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      155,
      '-29.076352',
      '-53.83894369999999',
      'Tupanciretã',
      'Hb',
      4322202,
      43017,
      'Santiago',
      4303,
      'Centro Ocidental Rio-grandense',
      9,
      'Cruz Alta',
    ],
    [
      156,
      '-29.1667089',
      '-51.5169861',
      'Bento Gonçalves',
      'Hb',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      157,
      '-30.0276639',
      '-51.0511093',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      158,
      '-29.4886595',
      '-51.9732508',
      'Estrela',
      'Hb',
      4307807,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      159,
      '-31.7761074',
      '-52.3414904',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      160,
      '-29.9998728',
      '-51.1080205',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      161,
      '-29.996648',
      '-51.043427',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      162,
      '-30.0078858',
      '-50.9217779',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      163,
      '-32.0476813',
      '-52.124659',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      164,
      '-29.692942',
      '-53.8204301',
      'Santa Maria',
      'Hb',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      165,
      '-32.04743990000001',
      '-52.1360607',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      166,
      '-28.0589672',
      '-52.679605',
      'Pontão',
      'Hb',
      4314779,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      167,
      '-27.3572419',
      '-52.1471676',
      'Mariano Moro',
      'Hb',
      4312005,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
      11,
      'Erechim',
    ],
    [
      168,
      '-30.014727',
      '-51.125426',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      169,
      '-29.9878617',
      '-51.1135487',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      170,
      '-29.9601455',
      '-51.1706916',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      171,
      '-29.9814797',
      '-53.4456216',
      'Formigueiro',
      'Hb',
      4308409,
      43019,
      'Restinga Seca',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      172,
      '-30.8909655',
      '-55.5330434',
      'Santana do Livramento',
      'Hb',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      173,
      '-28.979471',
      '-52.343193',
      'Fontoura Xavier',
      'Hb',
      4308300,
      43013,
      'Soledade',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      174,
      '-30.0268672',
      '-51.1079658',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      175,
      '-30.0286052',
      '-51.0676849',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      176,
      '-30.1274914',
      '-51.319178',
      'Guaíba',
      'Hb',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      177,
      '-28.2889827',
      '-52.43422349999999',
      'Passo Fundo',
      'Hb',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      178,
      '-31.7531188',
      '-52.30479',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      179,
      '-30.3074141',
      '-51.3210302',
      'Barra do Ribeiro',
      'Hb',
      4301909,
      43028,
      'Camaquã',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      180,
      '-31.7162865',
      '-52.3505615',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      181,
      '-29.7657336',
      '-57.07326949999999',
      'Uruguaiana',
      'Hb',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      182,
      '-30.0384445',
      '-51.10803840000001',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      183,
      '-30.1906326',
      '-52.3701301',
      'Pantano Grande',
      'Hb',
      4313953,
      43022,
      'Cachoeira do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      184,
      '-30.0746603',
      '-51.18017769999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      185,
      '-30.0250033',
      '-51.0609039',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      186,
      '-30.065691',
      '-51.0764769',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      187,
      '-29.7540528',
      '-57.09011640000001',
      'Uruguaiana',
      'Hb',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      188,
      '-31.750271',
      '-52.31220099999999',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      189,
      '-29.9281134',
      '-51.0666889',
      'Gravataí',
      'Hb',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      190,
      '-30.0072714',
      '-51.085297',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      191,
      '-29.99367609999999',
      '-51.1547682',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      192,
      '-32.0728365',
      '-52.1792104',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      193,
      '-30.0237782',
      '-51.12343509999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      194,
      '-30.0616628',
      '-51.2202492',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      195,
      '-29.9867956',
      '-51.0523402',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      196,
      '-29.6932522',
      '-51.469463',
      'Montenegro',
      'Hb',
      4312401,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      197,
      '-30.2476849',
      '-54.5813622',
      'São Gabriel',
      'Hb',
      4318309,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      198,
      '-30.0933096',
      '-51.1792189',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      199,
      '-29.7168644',
      '-51.3679914',
      'Capela de Santana',
      'Hb',
      4304689,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      200,
      '-29.0393623',
      '-52.4348239',
      'Fontoura Xavier',
      'Hb',
      4308300,
      43013,
      'Soledade',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      201,
      '-29.6866964',
      '-52.4077074',
      'Santa Cruz do Sul',
      'Hb',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      202,
      '-30.8680564',
      '-55.4860313',
      'Santana do Livramento',
      'Hb',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      203,
      '-30.0289806',
      '-52.91235409999999',
      'Cachoeira do Sul',
      'Hb',
      4303004,
      43022,
      'Cachoeira do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      8,
      'Cachoeira do Sul',
    ],
    [
      204,
      '-29.6687188',
      '-51.1550404',
      'Estância Velha',
      'Hb',
      4307609,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      205,
      '-30.081494',
      '-51.1922045',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      206,
      '-30.037645',
      '-51.1527315',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      207,
      '-30.5148445',
      '-53.4832383',
      'Caçapava do Sul',
      'Hb',
      4302808,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
      8,
      'Cachoeira do Sul',
    ],
    [
      208,
      '-31.3301424',
      '-54.1004622',
      'Bagé',
      'Hb',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
      7,
      'Bagé',
    ],
    [
      209,
      '-29.2398956',
      '-53.6957288',
      'Júlio de Castilhos',
      'Hb',
      4311205,
      43017,
      'Santiago',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      210,
      '-30.0516964',
      '-51.0968222',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      211,
      '-30.3471532',
      '-54.3260055',
      'São Gabriel',
      'Hb',
      4318309,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      212,
      '-30.065641',
      '-51.216558',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      213,
      '-29.9919366',
      '-51.0465934',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      214,
      '-31.334109',
      '-54.11499860000001',
      'Bagé',
      'Hb',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
      7,
      'Bagé',
    ],
    [
      215,
      '-29.8255063',
      '-51.1391161',
      'Sapucaia do Sul',
      'Hb',
      4320008,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      216,
      '-32.0599236',
      '-52.16601600000001',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      217,
      '-30.0378104',
      '-51.7082875',
      'Arroio dos Ratos',
      'Hb',
      4301107,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      218,
      '-31.7382571',
      '-52.31897319999999',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      219,
      '-30.87305049999999',
      '-55.48015419999999',
      'Santana do Livramento',
      'Hb',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      220,
      '-30.0478031',
      '-51.159319',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      221,
      '-30.0238803',
      '-51.1235629',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      222,
      '-32.0148238',
      '-52.03544549999999',
      'São José do Norte',
      'Hb',
      4318507,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      223,
      '-30.0112777',
      '-51.0925944',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      224,
      '-28.7615679',
      '-51.378038',
      'Ipê',
      'Hb',
      4310439,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      225,
      '-30.0298847',
      '-51.11683180000001',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      226,
      '-30.1893963',
      '-51.204986',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      227,
      '-30.0359085',
      '-51.2241407',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      228,
      '-29.9320352',
      '-51.166503',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      229,
      '-30.0234312',
      '-51.0671911',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      230,
      '-29.915197',
      '-51.1649284',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      231,
      '-30.08090979999999',
      '-51.0341761',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      232,
      '-30.1276159',
      '-51.3461583',
      'Guaíba',
      'Hb',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      233,
      '-28.372332',
      '-53.923811',
      'Ijuí',
      'Hb',
      4310207,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
      17,
      'Ijuí',
    ],
    [
      234,
      '-31.7637038',
      '-52.4994996',
      'Capão do Leão',
      'Hb',
      4304663,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      235,
      '-29.9011728',
      '-51.2190695',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      236,
      '-29.1634031',
      '-51.1796683',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      237,
      '-30.091011',
      '-51.0645584',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      238,
      '-30.1100222',
      '-51.3621916',
      'Guaíba',
      'Hb',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      239,
      '-30.0371211',
      '-51.1241893',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      240,
      '-30.0791686',
      '-51.1707669',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      241,
      '-31.7572632',
      '-52.3051431',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      242,
      '-29.9971983',
      '-51.06175529999999',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      243,
      '-32.0533546',
      '-52.1356876',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      244,
      '-29.3499652',
      '-50.79464669999999',
      'Canela',
      'Hb',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      5,
      'Caxias do Sul',
    ],
    [
      245,
      '-29.6889219',
      '-51.7337796',
      'Tabaí',
      'Hb',
      4320859,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      1,
      'Porto Alegre',
    ],
    [
      246,
      '-30.1362439',
      '-51.210904',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      247,
      '-28.4697099',
      '-50.8911395',
      'Vacaria',
      'Hb',
      4322509,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      248,
      '-29.916667',
      '-50.5',
      'Santo Antônio da Patrulha',
      'Hb',
      4317608,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      249,
      '-31.7152626',
      '-52.2921816',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      250,
      '-31.7607532',
      '-52.37164929999999',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      251,
      '-29.9708148',
      '-51.3272451',
      'Eldorado do Sul',
      'Hb',
      4306767,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      252,
      '-30.028562',
      '-51.0715999',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      253,
      '-30.1137208',
      '-51.1852359',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      254,
      '-29.97925',
      '-51.13034409999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      255,
      '-29.174321',
      '-51.5137552',
      'Bento Gonçalves',
      'Hb',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      256,
      '-30.0439298',
      '-51.1058646',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      257,
      '-29.7823031',
      '-55.7999184',
      'Alegrete',
      'Hb',
      4300406,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      258,
      '-29.3611189',
      '-50.8164904',
      'Canela',
      'Hb',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      5,
      'Caxias do Sul',
    ],
    [
      259,
      '-29.4372108',
      '-51.968207',
      'Lajeado',
      'Hb',
      4311403,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      260,
      '-29.2379114',
      '-51.3227416',
      'Farroupilha',
      'Hb',
      4307906,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      261,
      '-29.21358279999999',
      '-51.3527347',
      'Farroupilha',
      'Hb',
      4307906,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      262,
      '-30.0740345',
      '-51.1028059',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      263,
      '-29.707042',
      '-51.122587',
      'Novo Hamburgo',
      'Hb',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      264,
      '-29.7475946',
      '-52.4362704',
      'Santa Cruz do Sul',
      'Hb',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      265,
      '-29.446443',
      '-50.569885',
      'São Francisco de Paula',
      'Hb',
      4318200,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      1,
      'Porto Alegre',
    ],
    [
      266,
      '-30.0438469',
      '-51.1520443',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      267,
      '-29.160846',
      '-51.13340299999999',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      268,
      '-27.8547375',
      '-52.302281',
      'Erebango',
      'Hb',
      4306973,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
      11,
      'Erechim',
    ],
    [
      269,
      '-30.076746',
      '-51.2145814',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      270,
      '-29.9177974',
      '-51.1900026',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      271,
      '-30.5493387',
      '-52.532173',
      'Encruzilhada do Sul',
      'Hb',
      4306908,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
      8,
      'Cachoeira do Sul',
    ],
    [
      272,
      '-29.7744197',
      '-51.148922',
      'São Leopoldo',
      'Hb',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      273,
      '-30.080288',
      '-51.2381993',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      274,
      '-30.0072714',
      '-51.085297',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      275,
      '-29.90183',
      '-51.20984800000001',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      276,
      '-30.04624939999999',
      '-51.157708',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      277,
      '-30.8771554',
      '-55.5360442',
      'Santana do Livramento',
      'Hb',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      278,
      '-27.6433499',
      '-52.2750646',
      'Erechim',
      'Hb',
      4307005,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
      11,
      'Erechim',
    ],
    [
      279,
      '-29.9753721',
      '-51.178721',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      280,
      '-29.980241',
      '-51.19455900000001',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      281,
      '-30.0167475',
      '-51.12593099999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      282,
      '-30.04785579999999',
      '-52.8761978',
      'Cachoeira do Sul',
      'Hb',
      4303004,
      43022,
      'Cachoeira do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      8,
      'Cachoeira do Sul',
    ],
    [
      283,
      '-32.03593680000001',
      '-52.1143186',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      284,
      '-32.0578755',
      '-52.1509017',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      285,
      '-29.367477',
      '-50.8021624',
      'Canela',
      'Hb',
      4304408,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      5,
      'Caxias do Sul',
    ],
    [
      286,
      '-31.730148',
      '-52.3517314',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      287,
      '-29.6739112',
      '-53.82944740000001',
      'Santa Maria',
      'Hb',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      288,
      '-31.7519429',
      '-52.4307673',
      'Capão do Leão',
      'Hb',
      4304663,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      289,
      '-30.2786308',
      '-50.25444170000001',
      'Balneário Pinhal',
      'Hb',
      4301636,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      290,
      '-28.419797',
      '-52.2112554',
      'Marau',
      'Hb',
      4311809,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      291,
      '-30.1261748',
      '-51.08095369999999',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      292,
      '-29.2365243',
      '-51.8904514',
      'Encantado',
      'Hb',
      4306809,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      293,
      '-32.075923',
      '-52.1769986',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      294,
      '-30.02649509999999',
      '-51.1051816',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      295,
      '-30.0835032',
      '-51.0783701',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      296,
      '-29.1394921',
      '-51.1908168',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      297,
      '-31.7474816',
      '-52.3702228',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      298,
      '-30.0622249',
      '-51.0898851',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      299,
      '-29.12480639999999',
      '-51.1805919',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      300,
      '-29.9982569',
      '-51.0508971',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      301,
      '-30.0072714',
      '-51.085297',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      302,
      '-31.7644167',
      '-52.4330262',
      'Capão do Leão',
      'Hb',
      4304663,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      303,
      '-30.1260585',
      '-51.9659239',
      'Butiá',
      'Hb',
      4302709,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      304,
      '-29.5721817',
      '-50.7915585',
      'Igrejinha',
      'Hb',
      4310108,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      305,
      '-30.0110495',
      '-51.124143',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      306,
      '-30.2089693',
      '-51.1832669',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      307,
      '-30.0781515',
      '-51.1943754',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      308,
      '-29.7217884',
      '-52.4344467',
      'Santa Cruz do Sul',
      'Hb',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      309,
      '-29.86249279999999',
      '-51.1279173',
      'Esteio',
      'Hb',
      4307708,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      310,
      '-29.9038605',
      '-51.0180136',
      'Gravataí',
      'Hb',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      311,
      '-29.6890092',
      '-51.4839739',
      'Montenegro',
      'Hb',
      4312401,
      43023,
      'Montenegro',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      312,
      '-28.2925373',
      '-53.4811074',
      'Panambi',
      'Hb',
      4313904,
      43008,
      'Ijuí',
      4301,
      'Noroeste Rio-grandense',
      17,
      'Ijuí',
    ],
    [
      313,
      '-30.1214817',
      '-51.10115889999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      314,
      '-29.9635849',
      '-51.72286',
      'São Jerônimo',
      'Hb',
      4318408,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      315,
      '-30.1083731',
      '-51.1112103',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      316,
      '-30.15479869999999',
      '-51.1393006',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      317,
      '-30.1175585',
      '-51.2068058',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      318,
      '-30.8399498',
      '-51.82210860000001',
      'Camaquã',
      'Hb',
      4303509,
      43028,
      'Camaquã',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      319,
      '-29.727109',
      '-52.4303234',
      'Santa Cruz do Sul',
      'Hb',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      320,
      '-29.713757',
      '-53.8227322',
      'Santa Maria',
      'Hb',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      321,
      '-29.0791462',
      '-51.1084196',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      322,
      '-29.168085',
      '-51.5324032',
      'Bento Gonçalves',
      'Hb',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      323,
      '-29.7614456',
      '-57.1015585',
      'Uruguaiana',
      'Hb',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      324,
      '-30.1129924',
      '-51.167219',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      325,
      '-29.2030843',
      '-51.192135',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      326,
      '-29.0496417',
      '-50.1517407',
      'Cambará do Sul',
      'Hb',
      4303608,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      1,
      'Porto Alegre',
    ],
    [
      327,
      '-29.7432538',
      '-51.1383766',
      'São Leopoldo',
      'Hb',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      328,
      '-31.3064717',
      '-54.1059323',
      'Bagé',
      'Hb',
      4301602,
      43031,
      'Campanha Meridional',
      4306,
      'Sudoeste Rio-grandense',
      7,
      'Bagé',
    ],
    [
      329,
      '-29.9901323',
      '-51.1129773',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      330,
      '-29.6599122',
      '-50.7530714',
      'Taquara',
      'Hb',
      4321204,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      331,
      '-29.953461',
      '-51.186017',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      332,
      '-29.0250566',
      '-51.1669195',
      'Flores da Cunha',
      'Hb',
      4308201,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      333,
      '-29.992633',
      '-51.0985495',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      334,
      '-30.0217847',
      '-51.08971409999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      335,
      '-29.27124659999999',
      '-51.5156917',
      'Garibaldi',
      'Hb',
      4308607,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      336,
      '-32.0148238',
      '-52.03544549999999',
      'São José do Norte',
      'Hb',
      4318507,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      337,
      '-30.0213593',
      '-51.0923127',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      338,
      '-28.2952702',
      '-52.34741409999999',
      'Passo Fundo',
      'Hb',
      4314100,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      339,
      '-29.5905179',
      '-50.8089295',
      'Igrejinha',
      'Hb',
      4310108,
      43024,
      'Gramado-Canela',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      340,
      '-28.4689734',
      '-52.2053422',
      'Marau',
      'Hb',
      4311809,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      341,
      '-29.953461',
      '-51.186017',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      342,
      '-29.1916967',
      '-51.23813879999999',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      343,
      '-30.0265382',
      '-51.2108277',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      344,
      '-32.0395116',
      '-52.101445',
      'Rio Grande',
      'Hb',
      4315602,
      43035,
      'Litoral Lagunar',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      345,
      '-29.1538844',
      '-51.51613150000001',
      'Bento Gonçalves',
      'Hb',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      346,
      '-29.1595928',
      '-51.4929225',
      'Bento Gonçalves',
      'Hb',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      347,
      '-29.9010958',
      '-51.21614959999999',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      348,
      '-30.0346471',
      '-51.2176584',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      349,
      '-29.171194',
      '-51.1390812',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      350,
      '-29.1845119',
      '-51.2331209',
      'Caxias do Sul',
      'Hb',
      4305108,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      351,
      '-29.3871861',
      '-49.8379807',
      'Dom Pedro de Alcântara',
      'Hb',
      4306551,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      352,
      '-30.5454936',
      '-52.5257016',
      'Encruzilhada do Sul',
      'Hb',
      4306908,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
      8,
      'Cachoeira do Sul',
    ],
    [
      353,
      '-28.218857',
      '-51.5217036',
      'Lagoa Vermelha',
      'Hb',
      4311304,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      354,
      '-29.4557704',
      '-51.9672674',
      'Lajeado',
      'Hb',
      4311403,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      355,
      '-31.699222',
      '-52.321751',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      356,
      '-31.7214052',
      '-52.3453408',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      357,
      '-31.7427983',
      '-52.31106399999999',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      358,
      '-30.12698499999999',
      '-51.2173884',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      359,
      '-29.9825277',
      '-51.1945389',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      360,
      '-30.0079031',
      '-51.1231417',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      361,
      '-30.080268',
      '-51.1730816',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      362,
      '-29.9937544',
      '-51.1036532',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      363,
      '-29.991539',
      '-51.0983034',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      364,
      '-30.00093609999999',
      '-51.0974586',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      365,
      '-30.1151628',
      '-51.2454498',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      366,
      '-29.727109',
      '-52.4303234',
      'Santa Cruz do Sul',
      'Hb',
      4316808,
      43020,
      'Santa Cruz do Sul',
      4304,
      'Centro Oriental Rio-grandense',
      13,
      'Santa Cruz do Sul',
    ],
    [
      367,
      '-29.685475',
      '-53.83345490000001',
      'Santa Maria',
      'Hb',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      368,
      '-29.7870606',
      '-57.0594639',
      'Uruguaiana',
      'Hb',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      369,
      '-28.5053233',
      '-50.9400136',
      'Vacaria',
      'Hb',
      4322509,
      43015,
      'Vacaria',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      370,
      '-30.0557226',
      '-51.09457219999999',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      371,
      '-29.445782',
      '-51.969414',
      'Lajeado',
      'Hb',
      4311403,
      43021,
      'Lajeado-Estrela',
      4304,
      'Centro Oriental Rio-grandense',
      16,
      'Lajeado',
    ],
    [
      372,
      '-30.0393613',
      '-51.1250784',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      373,
      '-27.9183008',
      '-52.2631041',
      'Estação',
      'Hb',
      4307559,
      43004,
      'Erechim',
      4301,
      'Noroeste Rio-grandense',
      11,
      'Erechim',
    ],
    [
      374,
      '-29.92398589999999',
      '-51.0167207',
      'Gravataí',
      'Hb',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      375,
      '-29.78242729999999',
      '-55.7995112',
      'Alegrete',
      'Hb',
      4300406,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      376,
      '-29.6745533',
      '-53.8249793',
      'Santa Maria',
      'Hb',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      377,
      '-31.7553528',
      '-52.3507032',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      378,
      '-31.7427983',
      '-52.31106399999999',
      'Pelotas',
      'Hb',
      4314407,
      43033,
      'Pelotas',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      379,
      '-29.9917526',
      '-51.0998552',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      380,
      '-29.9937544',
      '-51.1036532',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      381,
      '-30.0180608',
      '-51.1263026',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      382,
      '-29.6788154',
      '-53.6900169',
      'Santa Maria',
      'Hb',
      4316907,
      43018,
      'Santa Maria',
      4303,
      'Centro Ocidental Rio-grandense',
      4,
      'Santa Maria',
    ],
    [
      383,
      '-29.1675897',
      '-51.5325413',
      'Bento Gonçalves',
      'Hb',
      4302105,
      43016,
      'Caxias do Sul',
      4302,
      'Nordeste Rio-grandense',
      5,
      'Caxias do Sul',
    ],
    [
      384,
      '-29.963261',
      '-51.6267808',
      'Charqueadas',
      'Hb',
      4305355,
      43025,
      'São Jerônimo',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      385,
      '-29.7702459',
      '-57.1069802',
      'Uruguaiana',
      'Hb',
      4322400,
      43029,
      'Campanha Ocidental',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      386,
      '-29.9376356',
      '-51.0586651',
      'Gravataí',
      'Hb',
      4309209,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      387,
      '-30.0986906',
      '-51.0581296',
      'Viamão',
      'Hb',
      4323002,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      388,
      '-30.16558599999999',
      '-51.4043424',
      'Guaíba',
      'Hb',
      4309308,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      389,
      '-30.8760779',
      '-52.251476',
      'Amaral Ferrador',
      'Hb',
      4300638,
      43032,
      'Serras de Sudeste',
      4307,
      'Sudeste Rio-grandense',
      3,
      'Pelotas',
    ],
    [
      390,
      '-28.4530433',
      '-52.1956688',
      'Marau',
      'Hb',
      4311809,
      43010,
      'Passo Fundo',
      4301,
      'Noroeste Rio-grandense',
      6,
      'Passo Fundo',
    ],
    [
      391,
      '-30.0055992',
      '-51.06829949999999',
      'Alvorada',
      'Hb',
      4300604,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      392,
      '-30.0880299',
      '-51.23259299999999',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      393,
      '-29.9581755',
      '-51.1676687',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      394,
      '-30.2133605',
      '-51.1791779',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      395,
      '-29.7368539',
      '-51.1481972',
      'São Leopoldo',
      'Hb',
      4318705,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      396,
      '-29.7105738',
      '-51.114786',
      'Novo Hamburgo',
      'Hb',
      4313409,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
    [
      397,
      '-29.9963691',
      '-51.1029578',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      398,
      '-30.159839',
      '-51.143126',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      399,
      '-29.7921084',
      '-50.4247294',
      'Caraá',
      'Hb',
      4304713,
      43027,
      'Osório',
      4305,
      'Metropolitana de Porto Alegre',
      18,
      'Osório',
    ],
    [
      400,
      '-29.996286',
      '-51.1054722',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      401,
      '-30.0057312',
      '-51.0903088',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      402,
      '-30.8606869',
      '-55.5330434',
      'Santana do Livramento',
      'Hb',
      4317103,
      43030,
      'Campanha Central',
      4306,
      'Sudoeste Rio-grandense',
      10,
      'Alegrete',
    ],
    [
      403,
      '-30.021252',
      '-51.095002',
      'Porto Alegre',
      'Hb',
      4314902,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      404,
      '-29.958973',
      '-51.1002633',
      'Cachoeirinha',
      'Hb',
      4303103,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      2,
      'Porto Alegre',
    ],
    [
      405,
      '-29.9578651',
      '-51.1686481',
      'Canoas',
      'Hb',
      4304606,
      43026,
      'Porto Alegre',
      4305,
      'Metropolitana de Porto Alegre',
      1,
      'Porto Alegre',
    ],
  ],
};

export default dataExample;
